<script>
    /**
     * The busy store of the dialog's action runner. Every button of the dialog is disabled
     * while an action is running, and the button of the running action shows a spinner.
     */
    export let busy;

    /**
     * The function to call when the button is clicked. Handlers wrapped by the action
     * runner get the spinner while they run. Plain functions can be used too, they are
     * only disabled along with the rest of the dialog.
     */
    export let action;

    /**
     * The bootstrap variant class of the button.
     */
    export let variant = 'btn-primary';

    export let title = '';

    export let name = null;

    $: running = $busy === action;
</script>

<button class="btn btn-sm {variant}" {title} {name} disabled={!!$busy} on:click={action}>
    <!-- The label keeps its space while the spinner is shown, so the button never resizes -->
    <span class="label" class:running><slot /></span>

    {#if running}
        <span class="spinner-border spinner-border-sm" aria-hidden="true" />
    {/if}
</button>

<style>
    button {
        position: relative;
    }

    /* Hidden with opacity rather than visibility, so that the button keeps both its size
       and its accessible name while the spinner is shown */
    .label.running {
        opacity: 0;
    }

    .spinner-border {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -0.5rem 0 0 -0.5rem;
    }
</style>
